// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageJson from '../../package.json';

export const environment = {
  appVersion: packageJson.version,
  production: false,
  baseURL: 'https://api-dev.everything.insure/v1/',
  signalrUrl: 'https://api-dev.everything.insure/hubs/notifications',
  //baseURL: 'http://localhost:64948/',
  cssURL: 'https://dev.everything.insure/',
  sendOTP: false,
  inProgress: true,
  eviAutofillEndpoint: 'https://0crxj35yhl.execute-api.eu-central-1.amazonaws.com/dev/v1/autofill',
  eviAutofillKey: 'OxgiXIjAJi19eB5nWGoMK319WrbkfPRl22ACbuCq',
  eviValidateEndpoint: 'https://yzf3elaq80.execute-api.eu-central-1.amazonaws.com/dev/v1/evidence/validate',
  eviValidateKey: 'bvW3Mum42bapARycymFXr5c10Ttc3sEx5az5K9YF',
  eviBaseEndpoint: 'https://yzf3elaq80.execute-api.eu-central-1.amazonaws.com/dev/v1/evidence',
  pdfServiceUrl: 'https://vader.everything.insure/pdf-v2/pdf/generate',
  googleMapsApiKey: 'AIzaSyDSzFFHZCtyGDb506fpmbASfWjQtu7EIG8',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
